/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { useState } from "react";
import {
  ACTION_CANCEL,
  ACTION_CANCEL_SUBMIT,
  ACTION_RETRACT,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
} from "../util/constants.js";
import ActionButton from "./fundamentals/ActionButton.jsx";
import TimeOffRequestEmployeeActionCheckDialog from "./TimeOffRequestEmployeeActionCheckDialog.jsx";
import { isLWOPTOWOPRequest } from "../util/timeOffRequestUtils.js";

const TimeOffRequestEmployeeAction = (props) => {
  const [isActionCheckDialogOpen, setIsActionCheckDialogOpen] = useState(false);
  const [actionSelected, setActionSelected] = useState("");

  const getStatusActions = (action, buttonText) => {
    return (
      <Grid container>
        <Grid item xs={6} md={12}>
          <ActionButton variant="contained" color="primary" onClick={() => handleActionClicked(action)}>
            {buttonText}
          </ActionButton>
        </Grid>
      </Grid>
    );
  };

  const getActionsBasedOnStatus = (status) => {
    switch (status) {
      case STATUS_SUBMITTED:
        return getStatusActions(ACTION_RETRACT, ACTION_RETRACT);
      case STATUS_APPROVED:
        return isLWOPTOWOPRequest(props.timeOffRequest.timeOffRequestType) ? (
          <div></div>
        ) : (
          getStatusActions(ACTION_CANCEL_SUBMIT, ACTION_CANCEL)
        );
      case STATUS_EXPIRED_ADM:
      case STATUS_RETRACTED:
      case STATUS_REFUSED:
      case STATUS_CANCEL_SUBMITTED:
      case STATUS_CANCELED_ADM:
      case STATUS_CANCELED_EE:
        return <div></div>;
      default:
        return "uh oh";
    }
  };

  const handleActionClicked = (actionName) => {
    setActionSelected(actionName);
    handleClickDialogOpen();
  };

  const handleClickDialogOpen = () => {
    setIsActionCheckDialogOpen(true);
  };

  const handleClickDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsActionCheckDialogOpen(false);
  };

  return (
    <div
      css={css`
        line-height: normal;
      `}
      data-testid="tor-employee-action"
    >
      {getActionsBasedOnStatus(props.timeOffRequest.visibleStatus)}
      {isActionCheckDialogOpen && (
        <TimeOffRequestEmployeeActionCheckDialog
          timeOffRequest={props.timeOffRequest}
          isDialogOpen={isActionCheckDialogOpen}
          actionSelected={actionSelected}
          onClickDialogClose={handleClickDialogClose}
          onTimeOffRequestDialogClose={props.onTimeOffRequestDialogClose ? props.onTimeOffRequestDialogClose : null}
        />
      )}
    </div>
  );
};

TimeOffRequestEmployeeAction.propTypes = {
  timeOffRequest: PropTypes.object.isRequired,
  onTimeOffRequestDialogClose: PropTypes.func,
};

export default TimeOffRequestEmployeeAction;
